<template>
  <upModel
    title="服务说明"
    :show="value"
    @close="close"
    :showCloseBtn="true"
    :autoHeight="true"
    :buttons="
      clickToLink
        ? [
            {
              label: '马上预约',
              desc: '咨询预沟通最低29.9元/次',
              onClick: () => $emit('toPreConsult')
            }
          ]
        : [
            {
              label: '我知道了',
              onClick: () => $emit('input', false)
            }
          ]
    "
    class="pre-consult-rule-model-container"
  >
    <div class="pre-consult-rule-model">
      <div />
      <div />
      <div />
    </div>
  </upModel>
</template>

<script>
import upModel from '../upModel/upModel.vue'

export default {
  components: {
    upModel
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    clickToLink: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    close() {
      this.$emit('input', false)
    }
  }
}
</script>

<style lang="scss">
@import '../../../scss/functions';

.pre-consult-rule-model-container {
  // 覆盖弹窗的样式
  .common-model-up-title {
    padding-bottom: pxToRem(16);
  }
}

.pre-consult-rule-model {
  box-sizing: border-box;
  max-height: calc(100vh - 4rem);
  overflow: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;

  & > div {
    width: 10rem;
    &:first-child {
      height: 726px;
      background: url(./img/preconsult-rule-1.jpg) 100% / 100% no-repeat;
    }
    &:nth-child(2) {
      height: 1194px;
      background: url(./img/preconsult-rule-2.jpg) 100% / 100% no-repeat;
    }
    &:nth-child(3) {
      height: 899px;
      background: url(./img/preconsult-rule-3.jpg) 100% / 100% no-repeat;
    }
  }
}
.pre-consult-rule-model-container .common-model-up-btn {
  background: linear-gradient(180deg, #bdc9fd 0%, #5d70f9 100%);
  font-size: 32px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  height: 86px;
  line-height: 86px;
}
</style>
